import { schema } from 'normalizr';
import { EntityTypes } from '@/api/types/entities';

export const formSchema = new schema.Entity(EntityTypes.Form);
